export default [
  {
    question: "Wie oft benutzt du die Maske?",
    answer1: "Immer",
    answer2: "Fast immer",
    answer3: "Häufig",
    answer4: "Manchmal",
    answer5: "Fast nie",
    answer6: "Noch nie",
    img: "/images/survey/mascarilla.svg",
    advice: "Sie sollten die Maske häufiger tragen.",
    inverted: true,
  },
  {
    question: "Wie oft waschen Sie Ihre Hände?",
    answer1: "Immer",
    answer2: "Fast immer",
    answer3: "Häufig",
    answer4: "Manchmal",
    answer5: "Fast nie",
    answer6: "Noch nie",
    img: "/images/survey/lavado-manos.svg",
    advice: "Sie sollten Ihre Hände häufiger waschen.",
    inverted: true,
  },
  {
    question:
      "Wie viele Stunden pro Woche bleiben Sie auf freiem Feld außer Haus?",
    answer1: "Mehr als 50",
    answer2: "40 bis 50",
    answer3: "30 bis 40",
    answer4: "20 bis 30",
    answer5: "10 bis 20",
    answer6: "0 bis 10",
    img: "/images/survey/espacios-abiertos.svg",
    advice: "",
    inverted: false,
  },
  {
    question:
      "Wie viele Stunden pro Woche bleiben Sie in geschlossenen Räumen außer Haus?",
    answer1: "Mehr als 50",
    answer2: "40 bis 50",
    answer3: "30 bis 40",
    answer4: "20 bis 30",
    answer5: "10 bis 20",
    answer6: "0 bis 10",
    img: "/images/survey/espacios-cerrados.svg",
    advice: "",
    inverted: false,
  },
  {
    question: "Wie oft berührst du dein Gesicht?",
    answer1: "Immer",
    answer2: "Fast immer",
    answer3: "Häufig",
    answer4: "Manchmal",
    answer5: "Fast nie",
    answer6: "Noch nie",
    img: "/images/survey/tocar-cara.svg",
    advice: "Achten Sie darauf, Ihr Gesicht nicht zu berühren.",
    inverted: false,
  },
  {
    question: "Wie viele Menschen leben außer Ihnen in Ihrem Haus?",
    answer1: "5 oder mehr",
    answer2: "4",
    answer3: "3",
    answer4: "2",
    answer5: "1",
    answer6: "0",
    img: "/images/survey/habitantes-casa.svg",
    advice: "",
    inverted: false,
  },
  {
    question:
      "Halten Sie die empfohlene soziale Distanz zum Rest der Menschen?",
    answer1: "Immer",
    answer2: "Fast immer",
    answer3: "Häufig",
    answer4: "Manchmal",
    answer5: "Fast nie",
    answer6: "Noch nie",
    img: "/images/survey/distanciamiento.svg",
    advice:
      "Versuchen Sie, den empfohlenen Abstand zu anderen Personen einzuhalten.",
    inverted: true,
  },
  {
    question: "Verwenden Sie Bargeld?",
    answer1: "Immer",
    answer2: "Fast immer",
    answer3: "Häufig",
    answer4: "Manchmal",
    answer5: "Fast nie",
    answer6: "Noch nie",
    img: "/images/survey/dinero.svg",
    advice: "",
    inverted: false,
  },
  {
    question:
      "Wie viele Minuten pro Woche benutzen Sie den Gemeinschaftsaufzug?",
    answer1: "Noch nie",
    answer2: "0 bis 2",
    answer3: "2 bis 5",
    answer4: "5 bis 10",
    answer5: "10 bis 20",
    answer6: "Mehr als 20",
    img: "/images/survey/ascensor.svg",
    advice:
      "Wenn möglich, benutzen Sie die Treppe, die Ihnen auch ein wenig Bewegung gibt.",
    inverted: true,
  },
  {
    question:
      "Wie viele Stunden pro Woche nutzen Sie die öffentlichen Verkehrsmittel?",
    answer1: "Mehr als 25",
    answer2: "20 bis 25",
    answer3: "15 bis 20",
    answer4: "10 bis 15",
    answer5: "5 bis 10",
    answer6: "0 bis 5",
    img: "/images/survey/transporte-publico.svg",
    advice: "",
    inverted: false,
  },
];
